<template>
    <div>
        <div class="c-panel c-panel--border c-panel--expand margin-b-24">
            <h3 class="margin-b-8">{{ request.is_tolk_opdracht == 0 ? 'Vertaler' : 'Tolk'}} toewijzen</h3>
            <div class="fs-small">Wijs een {{ request.is_tolk_opdracht == 0 ? 'vertaler' : 'tolk' }} toe om de opdracht uit te laten voeren.</div>

            <div class="margin-t-32" v-for="translation in request.vertalingen" :key="'translation-' + translation.id">
                <h4 class="margin-b-16" :class="{'td-line-through': translation.deleted_at}">{{ translation.brontaal.taal }} {{ request.is_tolk_opdracht ? '⇄' : '→' }} {{translation.doeltaal.taal}}</h4>

                <template  v-for="assigned in interpreters(translation)">
                    <div class="row margin-t-16" :key="'assigned-interperter-' + assigned.id">
                        <div class="column">{{ !hideNames ? assigned.opdrachtnemer.user.name : 'SIGV Coöperatie' }}<br/><span class="fs-small color-dark-gray">Tolk</span></div>
                        <div class="column shrink">
                            <c-status-label :label="false" :target="assigned" :assignment="true"></c-status-label>
                            <c-action :user="user" :assigned="assigned" :request="request"></c-action>
                        </div>
                    </div>
                </template>

                <template  v-for="assigned in translators(translation)">
                    <div class="row margin-t-16" :key="'assigned-translator-' + assigned.id">
                        <div class="column">{{ !hideNames ? assigned.opdrachtnemer.user.name : 'SIGV Coöperatie' }}<br/><span class="fs-small color-dark-gray">Vertaler{{ assigned.moet_reviseren ? ' + Reviseur' : '' }}</span></div>
                        <div class="column shrink">
                            <c-status-label :label="false" :target="assigned" :assignment="true"></c-status-label>
                            <c-action :user="user" :assigned="assigned" :request="request"></c-action>
                        </div>
                    </div>
                    <div class="row" v-if="showAddRevisor(assigned)" :key="'assigned-revisor-' + assigned.id">
                        <div class="column"><a href="#" class="color-primary fs-small" @click.prevent="openModel(translation, true)">Reviseur toevoegen</a></div>
                    </div>
                </template>

                <template  v-for="assigned in revisors(translation)">
                    <div class="row margin-t-16" :key="'assigned-reviser-' + assigned.id">
                        <div class="column">{{ !hideNames ? assigned.opdrachtnemer.user.name : 'SIGV Coöperatie' }}<br/><span class="fs-small color-dark-gray">Reviseur</span></div>
                        <div class="column shrink">
                            <c-status-label :label="false" :target="assigned" :assignment="true"></c-status-label>
                            <c-action :user="user" :assigned="assigned" :request="request"></c-action>
                        </div>
                    </div>
                </template>

                <button class="c-btn c-btn--secondary c-btn--hollow c-btn--small no-margin" @click="openModel(translation)" v-if="translation.opdrachtnemers.length == 0 ">{{ request.is_tolk_opdracht == 0 ? 'Vertaler' : 'Tolk'}} toewijzen</button>
                <button type="button" class="c-btn c-btn--secondary c-btn--hollow c-btn--small c-btn--expanded no-margin-b margin-t-32" @click="openModel(translation)" v-else>Toewijzigingen bekijken</button>
            </div>
        </div>

        <c-translator-assignment
            ref="modal"
            v-show="modal"
            @close="close"
            :request="request"
            :language="language"
            :reviser="reviser">
        </c-translator-assignment>
    </div>
</template>

<script>
import CTranslatorAssignment from '@app/modals/TranslatorAssignment.vue';
import CStatusLabel from '@components/StatusLabel.vue';
import { mapState } from 'vuex';
import CBlockComplete from '@components/blocks/Complete.vue';
import CAction from '@components/blocks/AssignedActions.vue';
import CModal from '@components/Modal.vue';

export default {
    components: { CTranslatorAssignment, CStatusLabel, CBlockComplete, CModal, CAction },
    props: {
        request: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            modal: false,
            language: null,
            reviser: false,
            showComplete: { },
        }
    },
    computed: {
        hideNames() {           
            return ( ( this.user.is_applicant && !this.user.is_planner && !this.user.is_translator && !this.request.is_anoniem) );
        },
        ...mapState({
            user: (state) => state.user.data
        })
    },
    methods: {
        toggleModal(id) {
            //met $set omdat vue niet herkent wanneer een key wordt toegevoegd aan een object
            this.$set( this.showComplete, id, !this.showComplete[id]);
        },
        interpreters(translation) {
            return translation.opdrachtnemers.filter( o => o.moet_vertalen == 0 && o.moet_reviseren == 0);
        },
        translators(translation) {
            return translation.opdrachtnemers.filter( o => o.moet_vertalen == 1);
        },
        revisors(translation) {
            return translation.opdrachtnemers.filter( o => o.moet_vertalen == 0 && o.moet_reviseren == 1);
        },
        close() {
            this.modal = false;
            this.language = null;
        },
        openModel(id, reviser) {
            this.language = id;
            this.reviser = ( reviser ) ? true : false;

            this.$nextTick( () => {
                this.$refs.modal.load();
                this.modal = true;
            });
        },
        showAddRevisor(assigned) {
            return assigned.moet_reviseren == 0
                && this.request.is_tolk_opdracht == 0
                && this.request.opdrachtgever.organisatie?.contract?.is_met_revisie == 1
        }
    }
}
</script>
